import UserSelectionsContainer from '@modules/sportOffer/UserSelectionsContainer.vue';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';

export const favouritesPage = {
    content: loadAsyncWithLoadingState<unknown>(() => import('./FavouritesPage.vue')),
    leftSidebar: () => import('@src/app/shared/modules/sportOffer/SdsFavouritesSidebar.vue'),
    rightSidebar: UserSelectionsContainer,
    // mobile
    mobileBottomContent: UserSelectionsContainer,
};
